import $ from "jquery";
import Cookies from "js-cookie";
import { gsap } from "gsap";

export default class Header {

  public body : HTMLElement;
  private element : HTMLElement;
  private hamburger : HTMLElement;

  constructor() {
    this.body = document.querySelector('body') as HTMLElement;
    this.element = document.querySelector('.header') as HTMLElement;
    this.hamburger = document.querySelector('.js-menu') as HTMLElement;
    // this.subnavSetting();
    this.onSPSubnav();
    this.onFontSizeHandler();
    this.onScroll();
    this.hamburger.addEventListener("click", this.navHandler.bind(this));
    $(window).on('scroll', (e) => {
      this.onScroll();
    });

    let fontsizecookie =  Cookies.get('fontsize') as string;
    this.onFontSizeChange(fontsizecookie);
  }

  subnavSetting():void {
    // $(document).on('click', '[data-has-submenu]', function(e) {
    //   console.log('click',e);
    // });

    const $menuItems = $('[data-has-submenu]');
    const $subMenu = $('.subnav');
    let isMainNavOn = false;
    let isSubNavOn = false;

    $("[data-has-submenu]").hover(function(e){
      let nav = e.currentTarget as HTMLAnchorElement;
      let navname = $(nav).data('has-submenu');
      let thisSubMenu = `.subnav[data-subnav="${navname}"]`;
      $(nav).find('a').addClass('is-active');
      isMainNavOn = true;
      gsap.killTweensOf(thisSubMenu);
      gsap.to(thisSubMenu, {
        duration: 0.3,
        autoAlpha: 1,
        ease: "none"
      });
      console.log(isMainNavOn, isSubNavOn);

    }, function(e){
      let nav = e.currentTarget as HTMLAnchorElement;
      let navname = $(nav).data('has-submenu');
      let thisSubMenu = `.subnav[data-subnav="${navname}"]`;
      isMainNavOn = false;

      gsap.killTweensOf(thisSubMenu);
      gsap.to(thisSubMenu, {
        duration: 0.3,
        autoAlpha: 0,
        ease: "none"
      });
      // if (e.relatedTarget !== nav) {
      // }
      if(isMainNavOn === false && isSubNavOn === false) {
        console.log(isMainNavOn, isSubNavOn);
        $(nav).find('a').removeClass('is-active');
      }
    });

    $subMenu.mouseover(function(e) {
      let nav = e.currentTarget as HTMLAnchorElement;
      let navname = $(nav).data('has-subnav');
      let thisMenu = `[data-has-submenu="${navname}"]`;
      $(thisMenu).find('a').addClass('is-active');
      isSubNavOn = true;

      gsap.killTweensOf(nav);
      gsap.to(nav, {
        duration: 0.3,
        autoAlpha: 1,
        ease: "none"
      });
      console.log(isMainNavOn, isSubNavOn);
    });
  
    $subMenu.mouseout(function(e) {
      // console.log(e.relatedTarget);
      // let nav = $(e.currentTarget).closest('[data-has-submenu]');
      let nav = e.currentTarget as HTMLAnchorElement;
      let navname = $(nav).data('has-subnav');
      let thisMenu = `[data-has-submenu="${navname}"]`;
      isSubNavOn = false;
      if (e.relatedTarget && !$(e.relatedTarget).closest($menuItems).length) {
        gsap.killTweensOf(nav);
        gsap.to(nav, {
          duration: 0.3,
          autoAlpha: 0,
          ease: "none"
        });
      }
      console.log(isMainNavOn, isSubNavOn);
    });
    
  }


  onScroll():void {

    let scrollTop : number = $(window).scrollTop()!;
    if(scrollTop > 50){
      this.element.classList.add('active');
    } else {
      this.element.classList.remove('active');
    }
  }

  onFontSizeHandler():void {
    
    $("[data-fontsize]").on('click', (e) => {
      let target = e.currentTarget as HTMLAnchorElement;
      let size = target.getAttribute('data-fontsize') as string;
      this.onFontSizeChange(size);
    });

  }

  onFontSizeChange(size:string ):void {
    let $target = $('[data-fontsize]');
    if(size === 'large') {
      $target[0].dataset.fontsize = 'default';
      $('html').removeClass('textLarge');
      Cookies.set('fontsize', 'large', { expires: 7 })
    } else if(size === 'default') {
      $target[0].dataset.fontsize = 'large';
      $('html').addClass('textLarge');
      Cookies.set('fontsize', 'default', { expires: 7 })
    }

  }

  onSPSubnav():void {
    $('[data-has-spsubmenu] > a').click(function (e) {
        e.preventDefault();
        var num = $('[data-has-spsubmenu]').index(this);
        var subnav = $(this).next();
        $(this).toggleClass('active');
        $(subnav).slideToggle();
    });
  }

  // cloneHeader():void {
  //   this.clonedHeaderNav = $(this.headerNav).clone(true).appendTo('#header');
  //   $(this.headerNav).addClass('topheader');
  //   this.clonedHeaderNav.addClass('cloned');
  // }


  navHandler(e: MouseEvent): void {

    if($('body').hasClass('nav-on')) {

      this.body.classList.remove('nav-on');
      $('.spnav').removeClass('is-active');

    } else {

      this.body.classList.add('nav-on');
      $('.spnav').addClass('is-active');

    }

  }

  // navCloseHandler(): void {
  //   this.body.classList.remove('nav-on');
  //   gsap.to('.spnav', {
  //     duration: 0.3,
  //     autoAlpha: 0
  //   });
  // }


  // anchorClickHandler(e: MouseEvent) {
  //   e.preventDefault();
  //   let nav = e.currentTarget as HTMLAnchorElement;
  //   // let queryname:string = nav.getAttribute('href') as string;
  //   let tag = document.querySelector(nav.hash) as HTMLElement;
  //   this.body.classList.remove('nav-on');
  // }

}
